
import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography, withStyles } from '@material-ui/core';
import { setTitle } from '../../shared/services/general/general-service';
import Footer from '../../components/footer/footer';
import FaqContent from './faq-content';

const useStyles = makeStyles((theme) => ({
	faqContainer: {
		marginTop: '10px !important',

		[theme.breakpoints.up('md')]: {
			marginTop: '80px !important',
		},
	},
}));

export default function Faq () {
	const classes = useStyles();

	useEffect(() => {
		setTitle('سوالات متداول');
	}, []);



	return (
		<>
			<div className={`container ${classes.faqContainer}`} style={{ margin: '30px auto' }}>
				<div className="max-width-menu section-title clearfix"><h1>سوالات متداول</h1></div>
				<FaqContent></FaqContent>
			</div>
			<Footer></Footer>
		</>
	);
}
